<template>
  <div class="layout" :class="{ 'is-mobile': isMobile }">
    <header v-if="!isMobile" class="layoutHeader">
      <div class="layoutHeaderLeft">
        <div class="logoRow">
          <div class="brand">
            <div class="logo" aria-hidden="true">
              <img src="/word_header_logo.png" alt="" />
            </div>
            <div>
              <div class="brandTitle">AI视频面试平台</div>
            </div>
          </div>
        </div>
      </div>
      <div class="layoutHeaderRight">
        <div class="headerUserInfo">
          <img class="headerAvatar" src="@/assets/defaultImg.png" alt="" aria-hidden="true" />
          <div class="headerUserMeta">
            <div class="headerUserName">{{ userName }}</div>
            <div class="headerUserJob">{{ userWorkNo }}</div>
          </div>
        </div>
        <el-button size="small" native-type="button" class="logoutBtn" @click="logout">退出登录</el-button>
      </div>
    </header>

    <InterviewerSidebar
      v-if="!isMobile"
      :user-name="userName"
      :department="userWorkNoText"
      version-text="版本：Preview"
      class="sidebarWrap"
    />

    <main class="main" :class="{ 'main--mobile': isMobile }">
      <router-view ref="childView" />
    </main>
  </div>
</template>

<script>
import InterviewerSidebar from "@/components/interviewer/InterviewerSidebar.vue";
import { clearToken } from "@/utils/token";

export default {
  name: "InterviewerLayout",
  components: { InterviewerSidebar },
  data() {
    return {
      isMobile: false,
    };
  },
  computed: {
    loginUserInfo() {
      const fromStore =
        this.$store && this.$store.state && this.$store.state.auth ? this.$store.state.auth.userInfo : null;
      if (fromStore) return fromStore;
      const parseRaw = (raw) => {
        if (!raw) return null;
        try {
          return JSON.parse(raw);
        } catch (_) {
          return null;
        }
      };
      return (
        parseRaw(sessionStorage.getItem("user_info")) ||
        null
      );
    },
    userName() {
      const u = this.loginUserInfo || {};
      return u.name || u.real_name || u.username || this.$route.query.user || "";
    },
    userWorkNoText() {
      const u = this.loginUserInfo || {};
      const workNo = u.work_no || u.workNo || "";
      return workNo ? `工号：${workNo}` : "";
    },
    userWorkNo() {
      const u = this.loginUserInfo || {};
      const workNo = u.work_no || u.workNo || "";
      return workNo ? String(workNo) : "";
    },
  },
  methods: {
    updateIsMobile() {
      if (typeof window === "undefined") {
        this.isMobile = false;
        return;
      }
      this.isMobile = window.innerWidth <= 768;
    },
    logout() {
      // 清理 token + store + 本地缓存
      clearToken();
      if (this.$store && typeof this.$store.commit === "function") {
        this.$store.commit("clearAuth");
      }
      try {
        localStorage.removeItem("user_info");
        sessionStorage.removeItem("user_info");
        sessionStorage.removeItem("login_user");
        sessionStorage.removeItem("access_token");
        sessionStorage.removeItem("token_type");
      } catch (e) {
        // ignore
      }
      this.$router.push("/");
    },
  },
  mounted() {
    this.updateIsMobile();
    if (typeof window !== "undefined") {
      window.addEventListener("resize", this.updateIsMobile);
    }
  },
  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.updateIsMobile);
    }
  },
};
</script>

<style>
/* 设计变量（来自原型） */
:root {
  --bg: #f5f7fa;
  --text: #1a1a2e;
  --muted: #6b7280;
  --line: rgba(0, 0, 0, 0.06);
  --brand: #4270f1;
  --ok: #22c55e;
  --warn: #f59e0b;
  --bad: #ef4444;
  --shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
  --r: 16px;
}
</style>

<style>
:root {
  --bg: #f5f7fa;
  --text: #1a1a2e;
  --muted: #6b7280;
  --line: rgba(0, 0, 0, 0.06);
  --brand: #4270f1;
  --ok: #22c55e;
  --warn: #f59e0b;
  --bad: #ef4444;
  --shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
  --r: 16px;
}
</style>

<style scoped>
.layout {
  min-height: 100vh;
  height: 100%;
  display: grid;
  grid-template-columns: 260px minmax(0, 1fr);
  grid-template-rows: 66px minmax(0, 1fr);
  background: var(--bg);
}

.layout.is-mobile {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  min-height: 100dvh;
  grid-template-columns: none;
  grid-template-rows: none;
}

.sidebarWrap {
  grid-column: 1;
  grid-row: 2;
}

.layoutHeader {
  grid-column: 1 / -1;
  grid-row: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 0 18px;
  border-bottom: 1px solid var(--line);
  background: #ffffff;
}

.layoutHeaderLeft {
  display: flex;
  flex-direction: column;
  gap: 0;
  min-width: 0;
}

.logoRow {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 0;
}

.brand {
  display: flex;
  align-items: center;
  gap: 14px;
}

.logo {
  width: 90px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
}

.logo img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: contain;
}

.brandTitle {
  font-size: 18px;
  margin-bottom: 3px;
  font-weight: 900;
  color: var(--text);
}

.layoutHeaderRight {
  display: flex;
  align-items: center;
  gap: 10px;
}

.headerUserInfo {
  display: flex;
  align-items: center;
  gap: 10px;
}

.headerAvatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  object-fit: cover;
  border: 1px solid var(--line);
  background: #ffffff;
}

.headerUserMeta {
  display: flex;
  flex-direction: column;
  gap: 2px;
  line-height: 1.1;
}

.headerUserName {
  font-size: 13px;
  font-weight: 800;
  color: var(--text);
}

.headerUserJob {
  font-size: 11px;
  color: var(--muted);
}

.logoutBtn {
  height: 36px;
  padding: 0 14px;
  border-radius: 10px;
  border: 1px solid var(--line);
  background: #ffffff;
  color: var(--muted);
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
}

.logoutBtn:hover {
  border-color: rgba(239, 68, 68, 0.35);
  color: #ef4444;
}

.main {
  grid-column: 2;
  grid-row: 2;
  padding: 18px 18px 16px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  overflow-y: auto;
}

.main.main--mobile {
  grid-column: auto;
  grid-row: auto;
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding: 10px 10px calc(14px + env(safe-area-inset-bottom, 0px));
  gap: 0;
  box-sizing: border-box;
}
</style>

<style>
/* 通用样式：表格/卡片/分页/弹窗/状态（供子页面复用） */
.cards {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
}

.card {
  border-radius: 5px;
  background: #f5f7fa;
  overflow: hidden;
}

.cardH {
  padding: 10px 12px;
  border-bottom: 1px solid var(--line);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font-size: 13px;
  background: #f8fafc;
}

.cardH strong {
  font-weight: 800;
}

table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

/* Element-UI: keep prototype style */
.cardB .el-table {
  font-size: 14px;
  color: var(--text);
}

.cardB .el-table__body-wrapper {
  overflow-x: auto;
}

.cardB .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
  background: #f8fafc;
}

.cardB .el-tabs__item {
  font-weight: 600;
}


th,
td {
  padding: 6px 4px;
  text-align: left;
  white-space: nowrap;
}

th {
  color: var(--muted);
  font-weight: 600;
  border-bottom: 1px solid var(--line);
}

td {
  border-bottom: 1px solid var(--line);
  color: var(--text);
}

tr:last-child td {
  border-bottom: none;
}

.col-report {
  width: 1%;
  min-width: 100px;
  white-space: nowrap;
}

.status {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 6px;
  border-radius: 999px;
  border: 1px solid var(--line);
  font-size: 11px;
  background: #f8fafc;
}

.status.ok {
  border-color: rgba(34, 197, 94, 0.3);
  background: rgba(34, 197, 94, 0.1);
  color: var(--ok);
}

.status.warn {
  border-color: rgba(245, 158, 11, 0.3);
  background: rgba(245, 158, 11, 0.1);
  color: var(--warn);
}

.status.bad {
  border-color: rgba(239, 68, 68, 0.3);
  background: rgba(239, 68, 68, 0.1);
  color: var(--bad);
}

.status.blue {
  border-color: rgba(66, 112, 241, 0.3);
  background: rgba(66, 112, 241, 0.1);
  color: var(--brand);
}

.status.gray {
  border-color: var(--line);
  background: #f1f5f9;
  color: var(--muted);
}

.btnLink {
  border-radius: 7px;
  padding: 4px 8px;
  font-size: 11px;
  border: 1px solid var(--line);
  background: #ffffff;
  cursor: pointer;
  text-decoration: none;
  color: var(--text);
  display: inline-flex;
  align-items: center;
}

.btnLink.primary {
  border-color: var(--brand);
  color: var(--brand);
}

.btnLink.danger {
  border-color: rgba(239, 68, 68, 0.3);
  color: var(--bad);
}

.btnLink.small {
  padding: 2px 6px;
  margin: 0 2px;
}

.stats-tabs {
  display: flex;
  align-items: center;
  gap: 4px;
  background: #f8fafc;
  border-radius: 30px;
  padding: 2px;
  border: 1px solid var(--line);
  margin-right: 12px;
}

.stat-tab {
  padding: 6px 16px;
  border-radius: 30px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  color: var(--muted);
  transition: all 0.1s;
  border: none;
  background: transparent;
}

.stat-tab.active {
  background: white;
  color: var(--brand);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  border: 1px solid var(--line);
}

.stat-tab:hover {
  color: var(--text);
}

.search-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 6px;
  background: #ffffff;
  padding: 14px 16px 16px;
  border: 1px solid #eee;
}

.search-input {
  display: flex;
  align-items: center;
  gap: 4px;
  border: 1px solid var(--line);
  border-radius: 30px;
  padding: 4px 12px;
  background: white;
  flex: 1 1 280px;
}

.search-input input {
  border: none;
  padding: 6px 0;
  font-size: 13px;
  width: 100%;
  outline: none;
  background: transparent;
}

.search-input span {
  color: var(--muted);
}

.clear-search {
  color: var(--brand);
  font-size: 12px;
  cursor: pointer;
  padding: 0 4px;
}



.page-item {
  border: 1px solid var(--line);
  background: white;
  border-radius: 8px;
  padding: 6px 10px;
  font-size: 12px;
  cursor: pointer;
  min-width: 32px;
  text-align: center;
}

.page-item.active {
  background: var(--brand);
  color: white;
  border-color: var(--brand);
}

.page-item.disabled {
  opacity: 0.4;
  pointer-events: none;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.modal-content {
  background: white;
  border-radius: 16px;
  padding: 20px;
  width: 500px;
  max-width: 90vw;
  box-shadow: var(--shadow);
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 0 0 16px;
}

.modal-header h3 {
  margin: 0;
  font-size: 18px;
}

.modal-close-btn {
  appearance: none;
  border: none;
  background: transparent;
  color: #909399;
  font-size: 24px;
  line-height: 1;
  padding: 0 6px;
  border-radius: 8px;
  cursor: pointer;
}

.modal-close-btn:hover {
  background: rgba(0, 0, 0, 0.05);
}

.modal-close-btn:focus {
  outline: none;
}

.modal-close-btn:focus-visible {
  outline: 2px solid rgba(66, 112, 241, 0.35);
  outline-offset: 2px;
}

.modal-content label {
  display: block;
  font-size: 12px;
  color: var(--muted);
  margin-bottom: 4px;
}

/* 排除 .el-input__inner，否则会覆盖 Element 日期/时间等选择器为图标预留的 padding */
.modal-content input:not(.el-input__inner),
.modal-content select {
  width: 100%;
  padding: 8px;
  border: 1px solid var(--line);
  border-radius: 8px;
  margin-bottom: 12px;
  font-size: 13px;
  font-family: inherit;
  background: white;
}

.modal-actions {
  display: flex;
  gap: 8px;
  margin-top: 16px;
}

.modal-actions button {
  flex: 1;
}

/**
 * 与「招聘 HR」Element Dialog 表单对齐：14px label、label-控件 6px 间距、表单项纵向 10px 节奏、
 * 原生输入与 el-select 高度 36px、底部取消/确认 右对齐（确认 primary）
 */
.modal-content.hr-like-modal .modal-body > label {
  display: block;
  font-size: 14px;
  line-height: 1.4;
  color: #606266;
  font-weight: normal;
  margin-bottom: 6px;
}

.modal-content.hr-like-modal .modal-body input[type="text"]:not(.el-input__inner),
.modal-content.hr-like-modal .modal-body input[type="tel"]:not(.el-input__inner),
.modal-content.hr-like-modal .modal-body input[type="email"]:not(.el-input__inner),
.modal-content.hr-like-modal .modal-body input[type="number"]:not(.el-input__inner) {
  width: 100%;
  height: 36px;
  box-sizing: border-box;
  padding: 0 15px;
  line-height: 36px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  margin-bottom: 10px;
  font-size: 14px;
  font-family: inherit;
  background: #fff;
}

.modal-content.hr-like-modal .modal-body input[type="text"]:not(.el-input__inner):focus:not(:disabled),
.modal-content.hr-like-modal .modal-body input[type="tel"]:not(.el-input__inner):focus:not(:disabled),
.modal-content.hr-like-modal .modal-body input[type="email"]:not(.el-input__inner):focus:not(:disabled),
.modal-content.hr-like-modal .modal-body input[type="number"]:not(.el-input__inner):focus:not(:disabled) {
  outline: none;
  border-color: #4270f1;
  box-shadow: none;
}

/* 须排在 [type="…"] 规则之后，否则禁用的灰底会被 background:#fff 盖掉 */
.modal-content.hr-like-modal .modal-body input[type="text"]:not(.el-input__inner):disabled,
.modal-content.hr-like-modal .modal-body input[type="tel"]:not(.el-input__inner):disabled,
.modal-content.hr-like-modal .modal-body input[type="email"]:not(.el-input__inner):disabled,
.modal-content.hr-like-modal .modal-body input[type="number"]:not(.el-input__inner):disabled {
  background-color: #f5f7fa !important;
  border-color: #e4e7ed !important;
  color: #c0c4cc !important;
  cursor: not-allowed;
  box-shadow: none;
  -webkit-text-fill-color: #c0c4cc;
}

.modal-content.hr-like-modal .modal-body .el-input.is-disabled .el-input__inner,
.modal-content.hr-like-modal .modal-body .el-textarea.is-disabled .el-textarea__inner {
  background-color: #f5f7fa !important;
  border-color: #e4e7ed !important;
  color: #c0c4cc !important;
  cursor: not-allowed;
}

.modal-content.hr-like-modal .modal-body .el-select {
  display: block;
  width: 100%;
  margin-bottom: 10px;
}

.modal-content.hr-like-modal .modal-body .el-select .el-input__inner {
  height: 36px;
  line-height: 36px;
  border-radius: 4px;
  font-size: 14px;
}

.modal-content.hr-like-modal .modal-body .el-select .el-input__suffix {
  display: block;
  height: 36px;
}

.modal-content.hr-like-modal .modal-body .el-select .el-input__suffix-inner {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 36px;
}

.modal-content.hr-like-modal .interview-time-row {
  margin-bottom: 10px;
}

.modal-content.hr-like-modal .file-upload {
  margin-bottom: 10px;
}

.modal-content.hr-like-modal .modal-body textarea.eval-textarea {
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 10px;
  padding: 8px 15px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-size: 14px;
  font-family: inherit;
  line-height: 1.5;
  color: #606266;
  background: #fff;
  resize: vertical;
}

.modal-content.hr-like-modal .modal-body textarea.eval-textarea:focus {
  outline: none;
  border-color: #4270f1;
  box-shadow: none;
}

/* Element 表单项：focus 只保留边框色，不要外圈阴影（与招聘 HR 弹框观感一致） */
.modal-content.hr-like-modal .modal-body .el-input__inner:focus,
.modal-content.hr-like-modal .modal-body .el-select .el-input.is-focus .el-input__inner,
.modal-content.hr-like-modal .modal-body .el-textarea__inner:focus {
  box-shadow: none !important;
}

.modal-content.hr-like-modal .eval-radio-group {
  margin-bottom: 10px;
}

.modal-content.hr-like-modal .modal-actions {
  justify-content: flex-end;
  margin-top: 10px;
}

.modal-content.hr-like-modal .modal-actions button,
.modal-content.hr-like-modal .modal-actions .el-button {
  flex: none !important;
  min-width: 80px;
}

.status-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 500;
  border: 1px solid transparent;
}

.status-official {
  background: #e0f2e0;
  color: #166534;
  border: 1px solid #86efac;
}

.status-probation {
  background: #fff3cd;
  color: #856404;
  border: 1px solid #ffe28c;
}

.status-resigned {
  background: #f1f5f9;
  color: #4b5563;
  border: 1px solid #d1d5db;
}

.status-pending {
  background: #ffe4e2;
  color: #b91c1c;
  border: 1px solid #fecaca;
}
</style>

